import { isRejectedWithValue } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { decryptUserId, encryptUserId } from "../utilis/encrypto";
// import BASE_URL from "../common";
import { BASE_URL } from "../constant";

// admin login
export function loginAdminapi(user) {
  return new Promise((resolve, reject) => {
    const headers = {
      'Content-Type': 'application/json',
    };

    axios
      .post(`${BASE_URL}/user/login`, user, { headers })
      .then(function (response) {
        if (response.data.status_code === 200) {
          const userData = response.data;
          localStorage.setItem('access_token', userData.access_token);
          if (userData.data.id) {
            const encryptedUserId = encryptUserId(userData.data.id);
            if (encryptedUserId) {
              localStorage.setItem('userId', encryptedUserId);
            } else {
              console.error('Failed to encrypt user ID.');
            }
          }
          toast.success(response.data.message);
          resolve(userData);
        }
        if (response.data.status_code !== 200) {
          toast.error(response.data.message);
        }
      })
      .catch(function (error) {
        // console.log('error', error);
        toast.error('Network error. Please check your connection.')
        reject(error);
      });
  });
}


export function signUpapi(user) {
  return new Promise((resolve, reject) => {
    const headers = {
      'Content-Type': 'application/json',
    };

    axios
      .post(`${BASE_URL}/user/signup`, user, { headers })
      .then((response) => {
        if (response.data.status_code === 200) {
          const userData = response.data;

          if (userData.user_id) {
            const encryptedUserId = encryptUserId(userData.user_id);
            if (encryptedUserId) {
              localStorage.setItem('userId', encryptedUserId);
            } else {
              console.error('Failed to encrypt user ID.');
            }
          }

          toast.success(userData.message);
          resolve(userData);
        } else {
          toast.error(response.data.message);
          reject(new Error(response.data.message));
        }
      })
      .catch((error) => {
        // console.error('error', error);
        toast.error('Network error. Please check your connection.');
        reject(error);
      });
  });
}

export function otpapi(user) {
  return new Promise((resolve, reject) => {
    const headers = {
      'Content-Type': 'application/json',
    };

    axios
      .post(`${BASE_URL}/user/verify-otp`, user, { headers })
      .then(function (response) {
        if (response.data.status_code === 200) {
          const userData = response.data;

          if (userData.access_token) {
            localStorage.setItem('access_token', userData.access_token);
          }
          toast.success(response.data.message);
          resolve(userData);
        }
        if (response.data.status_code !== 200) {
          toast.error(response.data.message);
        }
      })
      .catch(function (error) {
        // console.log('error', error);
        toast.error('Network error. Please check your connection.');
        reject(error);
      });
  });
}
export function ForgetPasswordapi(email) {
  return new Promise((resolve, reject) => {
    const headers = {
      'Content-Type': 'application/json',
    };

    axios
      .post(`${BASE_URL}/user/forgot_password?email=${email}`, { headers })
      .then(function (response) {
        if (response.data.status === 'success') {
          const userData = response.data;

          if (userData.user_id) {
            const encryptedUserId = encryptUserId(userData.user_id);
            if (encryptedUserId) {
              localStorage.setItem('userId', encryptedUserId);
            } else {
              console.error('Failed to encrypt user ID.');
            }
          }
          toast.success(response.data.message);
          resolve(response.data)
        }
        if (response.data.status !== "success") {
          toast.error(response.data.message);
        }
      })
      .catch(function (error) {
        // console.log('error', error);

        toast.error('Network error. Please check your connection.');


        reject(error);
      });
  });
}

export function createNewpassword(user) {
  return new Promise((resolve, reject) => {
    const headers = {
      'Content-Type': 'application/json',
    };

    axios
      .post(`${BASE_URL}/user/create_new_password`, user)
      .then(function (response) {
        if (response.data.status === 'success') {
          toast.success(response.data.message);
          resolve(response.data)
        }
        if (response.data.status !== "success") {
          toast.error(response.data.message);
        }
      })
      .catch(function (error) {
        // console.log('error', error);
        toast.error('Network error. Please check your connection.');
        reject(error);
      });
  });
}
export function changePassword(user) {
  return new Promise((resolve, reject) => {
    
    const token = localStorage.getItem('access_token');

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    };

    axios
      .post(`${BASE_URL}/user/change_password`, user, { headers }) // Pass headers here
      .then(function (response) {
        if (response.data.status === 'success') {
          toast.success(response.data.message);
          resolve(response.data);
        } else {
          toast.error(response.data.message);
          reject(response.data);
        }
      })
      .catch(function (error) {
        // console.log('error', error);
        toast.error('Network error. Please check your connection.');
        reject(error);
      });
  });
}

export function Resendotp(user) {
  return new Promise((resolve, reject) => {
    
    const token = localStorage.getItem('access_token');

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    };

    axios
      .post(`${BASE_URL}/user/resend_otp`, user, { headers }) // Pass headers here
      .then(function (response) {
        if (response.data.status === 'success') {
          toast.success(response.data.message);
          resolve(response.data);
        } else {
          toast.error(response.data.message);
          reject(response.data);
        }
      })
      .catch(function (error) {
        // console.log('error', error);
        toast.error('Network error. Please check your connection.');
        reject(error);
      });
  });
}


export function Getprofile(userid) {
  return new Promise((resolve, reject) => {
    const headers = {
      'Content-Type': 'application/json',
    };
    const encryptedUserId = localStorage.getItem("userId");
    const decryptedUserId = decryptUserId(encryptedUserId);

    if (!decryptedUserId) {
      console.error("Failed to decrypt user ID.");
      return reject(new Error("Failed to decrypt user ID."));
    }

    axios
      .get(`${BASE_URL}/user/get_profile/${decryptedUserId}`)
      .then(function (response) {
        if (response.data.status === 'success') {
          // toast.success(response.data.message);
          resolve(response.data)
        }
        if (response.data.status !== "success") {
          // toast.error(response.data.message);
        }
      })
      .catch(function (error) {
        // console.log('error', error);

        toast.error('Network error. Please check your connection.');


        reject(error);
      });
  });
}

export function UpdateProfile(user) {
  return new Promise((resolve, reject) => {
    
    const token = localStorage.getItem('access_token');

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    };

    axios
      .post(`${BASE_URL}/user/update_profile`, user, { headers }) // Pass headers here
      .then(function (response) {
        if (response.data.status === 'success') {
          toast.success(response.data.message);
          resolve(response.data);
        } else {
          toast.error(response.data.message);
          reject(response.data);
        }
      })
      .catch(function (error) {
        // console.log('error', error);
        toast.error('Network error. Please check your connection.');
        reject(error);
      });
  });
}
export function SocialLogin(user) {
  return new Promise((resolve, reject) => {
    

    const headers = {
      'Content-Type': 'application/json',
    };

    axios
      .post(`${BASE_URL}/user/social_login`, user, { headers }) 
      .then(function (response) {
        if (response.data.status === 'success') {
          const userData = response.data;

          if (userData.access_token) {
            localStorage.setItem('access_token', userData.access_token);
          }
          if (userData.data.id) {
            const encryptedUserId = encryptUserId(userData.data.id);
            if (encryptedUserId) {
              localStorage.setItem('userId', encryptedUserId);
            } else {
              console.error('Failed to encrypt user ID.');
            }
          }
          toast.success(response.data.message);
          resolve(response.data)
        } else {
          toast.error(response.data.message);
          reject(response.data);
        }
      })
      .catch(function (error) {
        // console.log('error', error);
        toast.error('Network error. Please check your connection.');
        reject(error);
      });
  });
}
export function Logout() {
  return new Promise((resolve, reject) => {
    const config = {
      headers: {
        'Content-Type': 'application/json',

        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };
    // console.log(localStorage.getItem("access_token")); // Debugging token

    axios
      .post(`${BASE_URL}/user/logout`, null, config) // Pass headers as the third parameter
      .then(function (response) {
        if (response.data.status === 'success') {
          toast.success(response.data.message);
          resolve(response.data); // Ensure resolve is called on success
        } else {
          toast.error(response.data.message);
          reject(response.data); // Ensure reject is called on failure
        }
      })
      .catch(function (error) {
        toast.error('Network error. Please check your connection.');
        reject(error); // Pass the error to the calling function
      });
  });
}





const apiServices = {
  loginAdminapi,
  signUpapi,
  otpapi,
  ForgetPasswordapi,
  createNewpassword,
  changePassword,
  Resendotp,
  Getprofile,
  UpdateProfile,
  SocialLogin,
  Logout
};

export default apiServices;
